import { isArray } from 'util';
import APIS from 'src/constants/ApiConfig';
import HttpService from './HttpService';
import { message } from 'antd';
import I18N from './I18NService';

export declare type UploadFileStatus = 'error' | 'success' | 'done' | 'uploading' | 'removed';

/** 文件对象 */
export interface UploadFile {
  uid: string;
  size: number;
  name: string;
  filename?: string;
  lastModified?: string;
  lastModifiedDate?: Date;
  url?: string;
  status?: UploadFileStatus;
  originFileObj?: File;
  percent?: number;
  thumbUrl?: string;
  response?: any;
  error?: any;
  linkProps?: {
    download: string;
  };
  type: string;
  [key: string]: any;
}

/**
 * flex/private接口 返回的bucket信息
 */
export interface IBucketInfo {
  bucket_uuid: string;
  expire_time: string;
  modified_time: string;
}

interface BucketDetail {
  status: string;
  added_files: Array<{ file: string; key: string }>;
}

/**
 * 创建Bucket参数
 */
export interface CreateBucketParam {
  /** 存储区类型， 例如"medical_record_img" */
  bucket_type: string;
  /** 存储区用户信息 */
  intro: any;
}

/** 获取bucket默认参数 */
export const defaultBucketParam: CreateBucketParam = {
  bucket_type: 'partner_unknown_img',
  intro: { name: 'unknown' },
};

class FlexApiService {
  private privateUrl = APIS.flexUrl('private/');
  private publicUrl = APIS.flexUrl('');
  private http = HttpService;

  async createBucket(param: CreateBucketParam): Promise<IBucketInfo | undefined> {
    try {
      const res = await this.http.post(this.privateUrl, param);
      return res;
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_search_failure'));
      }
      return undefined;
    }
  }

  /**
   * @description 上传链接图片
   */
  async uploadJumpLinkPic(bucket: IBucketInfo, file: Blob): Promise<string> {
    if (!bucket) {
      return '';
    }
    const form = new FormData();
    form.append('bucket_uuid', bucket.bucket_uuid);
    form.append('jump_link_img', file);
    try {
      const uploadRes: BucketDetail | undefined = await this.http.patch(this.publicUrl, form);
      let uploadPath: string | undefined;
      if (!!uploadRes && isArray(uploadRes.added_files)) {
        uploadPath = !!uploadRes.added_files[0] && uploadRes.added_files[0].file;
      }
      if (!uploadPath) {
        console.error('upload failed');
      } else {
        return uploadPath;
      }
    } catch (error) {
      console.error('logoUpload: ', error);
      console.error('upload failed');
    }

    return '';
  }
}

export default new FlexApiService();



// WEBPACK FOOTER //
// ./src/services/FlexApiService.ts